export enum ColorLineConstants {
    TWIRE = "T-WIRE",
    TPLATE = "T-PLATE",
    GROOVE  = "T4046"
}
